module.exports = __webpack_public_path__ + "img/ic_delete.a84944aa.svg";